import { Injectable } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { filter, mapTo, take, tap } from 'rxjs/operators';
import { DataService } from '@Core/services/proprietary/data.service';
import { Datasource, DataSourceStatus } from '@Core/services/proprietary/datasource';

@Injectable()
export class ObjectService {
    private dsObject: Datasource;

    dsObjectStatusSub: Subscription;

    objectDictionaryLoaded: boolean = false;

    constructor(private ds: DataService) {
        ///TODO - Figure out how often this is refreshed. Have to refresh when changing Book or BookLoc.
        this.dsObject = ds.addNewDatasource('ObjectConfig', 'NO-CACHE');
        this.dsObject.maxRowLimiter = false;
    }

    loadObjects(g1: string = 'Y;N', g2: string = 'Y;N', disabled: string = 'N') {
        this.objectDictionaryLoaded = false;
        if (this.dsObjectStatusSub) {
            this.dsObjectStatusSub.unsubscribe();
        }

        this.dsObject.getCollection({
            json: 'CT2',
            View: 'Full',
            G1_Ind: g1,
            G2_Ind: g2,
            Disabled_Ind: disabled
        });

        this.dsObjectStatusSub = this.dsObject.status$.subscribe((status) => {
            this.objectCollectionRetrieved(status);
        });
    }

    objectCollectionRetrieved(status: DataSourceStatus) {
        switch (status) {
            case DataSourceStatus.Ready:
                if (this.dsObjectStatusSub) {
                    this.dsObjectStatusSub.unsubscribe();
                }
                this.objectDictionaryLoaded = true;
                break;
            case DataSourceStatus.Error:
                if (this.dsObjectStatusSub) {
                    this.dsObjectStatusSub.unsubscribe();
                }
                this.objectDictionaryLoaded = false;
                break;
        }
    }

    getLoadObjectsStatus(): Observable<DataSourceStatus> {
        return this.dsObject.status$;
    }

    getObjectConfig(objectCode: string) {
        let object: any = {};
        let index = -1;
        if (!objectCode || objectCode == '') {
            return;
        }

        index = this.dsObject.objectNodes.map((x) => x.Object_Code.toLowerCase()).indexOf(objectCode.toLowerCase());
        if (index != -1) {
            object = this.dsObject.objectNodes[index];
            return object;
        } else {
            return;
        }
    }

    getObjectRoute(objectCode: string) {
        let route: string = '';
        let index = -1;
        if (objectCode && objectCode != '') {
            index = this.dsObject.objectNodes.map((x) => x.Object_Code.toLowerCase()).indexOf(objectCode.toLowerCase());
            if (index != -1) {
                route = this.dsObject.objectNodes[index].G2_Route;
            }
        }

        return route;
    }

    getObjectFromRoute(route: string) {
        let object: any = {};
        let index = -1;
        if (!route || route == '') {
            return;
        }

        index = this.dsObject.objectNodes.map((x) => x.G2_Route).indexOf(route);
        if (index != -1) {
            object = this.dsObject.objectNodes[index];
            return object;
        } else {
            return;
        }
    }

    getObjectList(excludeSubObjects: boolean = true, excludedObjectClass: any = []): [] {
        let objectList: any = [];
        this.dsObject.objectNodes.forEach((object) => {
            if (object.Sub_Object_Ind == 'N' || (object.Sub_Object_Ind == 'Y' && !excludeSubObjects)) {
                if (excludedObjectClass.length == 0 || !excludedObjectClass.includes(object.Object_Class)) {
                    objectList.push({ Code: object.Object_Code, Code_Desc: object.Object_Name });
                }
            }
        });

        return objectList;
    }

    getObjectListByObjectClass(
        ObjectClass: string[],
        g2ObjectsOnly: boolean = true,
        ignoreUserRights: boolean = false
    ): [] {
        let objectList: any = [];
        this.dsObject.objectNodes.forEach((object) => {
            if (
                ObjectClass.includes(object.Object_Class) &&
                (!g2ObjectsOnly || object.G2_Ind == 'Y') &&
                (ignoreUserRights || (object.User_Rights && object.User_Rights.View_Object_Ind == 'Y'))
            ) {
                objectList.push(object);
            }
        });
        return objectList;
    }

    refresh() {
        this.dsObject.reset();
        this.loadObjects();
    }

    isObjDictionaryLoaded() {
        if (!this.objectDictionaryLoaded) {
            return this.getLoadObjectsStatus()
                .pipe(
                    filter((status) => status != DataSourceStatus.Loading),
                    mapTo(true),
                    tap(() => {
                        this.objectDictionaryLoaded = true;
                    }),
                    take(1)
                )
                .toPromise();
        } else {
            return Promise.resolve(true);
        }
    }
}
